import styled from "styled-components";
const disabledMenuItemStyle = (theme) => `color: ${theme.colors.black};
  opacity: 26%;
  border: 1px ${theme.colors.black};
  cursor: text;
`;
function hoverStyle(isDisabled, isActive, theme) {
    if (isDisabled) {
        return `background: ${theme.colors.white}`;
    }
    if (isActive) {
        return `background: auto`;
    }
    return `background: ${theme.colors.grey10}`;
}
export const StyledLi = styled.li `
  &&& {
    display: inline-flex;
    list-style: none;
    margin-right: 2rem;
    position: relative;
    height: 100%;
    align-items: center;
    pointer-events: auto;
    cursor: pointer;
    ${({ isDisabled, theme }) => isDisabled ? disabledMenuItemStyle(theme) : ""};
    &:after {
      box-sizing: border-box;
      width: calc(100% + 2px);
      content: '';
      position: absolute;
      left: 0px;
      bottom: 0;
      height: 0.25rem;
      background-color: ${({ isActive, theme }) => {
    return isActive ? theme.colors.primaryLight : "transparent";
}};
    }

    &:hover {
      &:after {
        ${({ isActive, isDisabled, theme }) => hoverStyle(isDisabled, isActive, theme)};
      }
    }

    &:after {
      ${({ focusVisible, isActive, theme }) => focusVisible && !isActive ? `background-color: ${theme.colors.grey10};` : ""};
    }

    &:active {
      &:after {
        ${({ isDisabled, theme }) => isDisabled
    ? `background:auto`
    : `background: ${theme.colors.grey15}`};
      
      }
    }

    > a {
      all: unset;
      overflow: hidden;
      outline: none;
      font-size: ${({ theme }) => theme.fontTokens.font11[0]};
      line-height: ${({ theme }) => theme.fontTokens.font11[1]};
      font-weight: 400;
      display: flex;
      align-items: center;
      height: 2.5rem;
      box-sizing: border-box;
      border: 1px solid transparent;
      ${({ focusVisible }) => focusVisible
    ? `border: 1px solid ${({ theme }) => theme.colors.primaryLight}`
    : ""};

      ${({ focusVisible }) => focusVisible
    ? `outline: 1px solid ${({ theme }) => theme.colors.primaryLight}`
    : ""};
    }
  }
`;
